module.exports = __webpack_public_path__ + "static/media/stockhausen_held_11.b270ad41.png";